export default __webpack_public_path__ + "static/1.1_DE-c7b01a515400708beeb526ce0f671c42.webp";